import { CancelButtons } from "@/app/(application)/(normal)/account/components/cancelSubscriptionLink/cancelSubscriptionModal/CancelButtons";
import { NormalText } from "@/components/text/NormalText";

export function ConnectSupport({
  title,
  onContact,
  onContinueCancellation,
}: {
  title: string;
  onContact: () => void;
  onContinueCancellation: () => void;
}) {
  return (
    <div className="space-y-4">
      <NormalText elementType="p">{title}</NormalText>
      <CancelButtons
        positiveText="Contact us"
        negativeText="Continue with cancellation"
        onPositive={onContact}
        onNegative={onContinueCancellation}
      />
    </div>
  );
}
